import React, {Component} from 'react';
import {Button, Card, CardBody, CardTitle} from 'reactstrap';

class ResultCard extends Component {
	render() {
		return (
			<Card className={`resultCard result-${this.props.num}`}>
				<CardBody>
					<h4><span>{this.props.result.prop_num}</span></h4>
					<div className="resultCardData">
						<p><span>Property Name:</span> {this.props.result.property_name}</p>
						<p><span>Client Name:</span> {this.props.result.client_name}</p>
						<p><span>Site Address:</span> {this.props.result.site_address}</p>
						<p><span>Aliases:</span> {this.props.result.aliases}</p></div>
					<Button
						color="info"
						onClick={() => {
							this.props.handleGetRouteFromSearch(this.props.result.prop_num);
						}}
					></Button>
				</CardBody>
			</Card>
		);
	}
}

export default ResultCard;



// WEBPACK FOOTER //
// ./src/components/ResultCard.js